import { BaseApi } from './base_api';
import { exposeIframeBridge } from 'utilities/communication';
import { EXTENSION_API, PLAYER_CONTROL_EVENT } from 'constants/events';

const ORIGIN_WHITELIST = ['https://hapyak_uploads.s3.amazonaws.com', 'https://hapyak-widgets.s3.amazonaws.com'];

export class ExtensionApi extends BaseApi {
    setup() {
        this.bridge = exposeIframeBridge(ORIGIN_WHITELIST);
        this.handleInstructions();
    }

    handleInstructions() {
        this.bridge.on(EXTENSION_API.PLAY, () => this.eventBus.emit(PLAYER_CONTROL_EVENT.PLAY));
        this.bridge.on(EXTENSION_API.PAUSE, () => this.eventBus.emit(PLAYER_CONTROL_EVENT.PAUSE));
        this.bridge.on(EXTENSION_API.MUTE, () => this.eventBus.emit(PLAYER_CONTROL_EVENT.MUTE, true));
        this.bridge.on(EXTENSION_API.UNMUTE, () => this.eventBus.emit(PLAYER_CONTROL_EVENT.UNMUTE, false));
        this.bridge.on(EXTENSION_API.CURRENT_TIME, e => this.eventBus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, e.time));

        // relay out all extension api messages in case another module wants to use them
        Object.values(EXTENSION_API).map(this.relay.bind(this));
    }

    relay(eventName) {
        this.bridge.on(eventName, (...args) => this.eventBus.emit(eventName, ...args));
    }
}